import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageSimple } from '@fuse';
import { Icon, Button, IconButton, Grid } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from './store/actions';
import { withRouter } from 'react-router-dom';
import AssetPreview from './AssetPreview';

const styles = theme => ({
    layoutRoot: {},
});

class AssetList extends Component {

    state = {
        preview: false,
        preview_id: null,
        preview_url: null
    }

    constructor(props) {
        super(props);
        this.props.getAssetList();
    }

    handleRowClick(page_type, asset_id, asset_URL) {
        this.setState({ preview: true, preview_id: asset_id, preview_url: asset_URL }, () => {
        })
    }

    render() {
        const { classes, assetList } = this.props;
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24"><h4>Asset List</h4></div>
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">

                        {this.props.auth.user.role === "student" || this.props.auth.user.role === "null" || this.props.auth.user.role === "guest" ?
                            null
                            :
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.styles}
                                onClick={() => this.props.history.push("/asset/create")}
                            >
                                Add New
                            </Button>
                        }

                    </div>
                }
                content={
                    <div className="px-24">
                        <Grid container spacing={24}>
                            <Grid item xs={3}>
                                {this.preview(this.state.preview_id)}
                            </Grid>
                            <Grid item xs={9}>
                                <ReactTable
                                    columns={[
                                        {
                                            Header: "Preview",
                                            Cell: row => (
                                                <div className="flex items-center">
                                                    <IconButton
                                                        style={{ paddingBottom: '0px', paddingTop: '0px' }}
                                                        onClick={(ev) => {
                                                            ev.stopPropagation();
                                                            this.handleRowClick('preview', row.original.asset_id, row.original.URL);
                                                        }}
                                                    >
                                                        <Icon>pageview</Icon>
                                                    </IconButton>

                                                </div>
                                            )
                                        },
                                        {
                                            Header: "Asset Name",
                                            accessor: "AssetName"
                                        },
                                        {
                                            Header: "Asset Type",
                                            accessor: "AssetType"
                                        },
                                        {
                                            Header: "Local/Remote",
                                            accessor: "LocalRemote"
                                        },
                                        {
                                            Header: "",
                                            Cell: row => (
                                                <div className="flex items-center">
                                                    <IconButton
                                                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                        onClick={(ev) => {
                                                            ev.stopPropagation();
                                                            this.handleRowClick('preview', row.original.asset_id, row.original.URL);
                                                        }}
                                                    >
                                                        <Icon>library_books</Icon>
                                                    </IconButton>

                                                    {this.props.auth.user.role === "student" || this.props.auth.user.role === "null" || this.props.auth.user.role === "guest" ?
                                                        null
                                                        :
                                                        <IconButton
                                                        style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                                            onClick={(ev) => {
                                                                ev.stopPropagation();
                                                                this.handleRowClick('edit', row.original.asset_id);
                                                            }}
                                                        >
                                                            <Icon>border_color</Icon>
                                                        </IconButton>
                                                    }

                                                </div>
                                            )
                                        }
                                    ]}
                                    data={assetList}
                                    defaultPageSize={25}
                                    className="-striped -highlight"
                                    noDataText="No Assets Found"
                                />

                            </Grid>
                        </Grid>
                    </div>
                }
            />
        )
    }
    preview = prop => {
        return prop ?
            <div>
                <AssetPreview asset_id={this.state.preview_id} asset_url={this.state.preview_url} />
            </div> :
            <div>
                <h3>Preview</h3>  <img src='assets/images/logos/photo-camera.jpg' alt='' />
            </div>
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getAssetList: Actions.getAssetList,
    }, dispatch);
}

function mapStateToProps({ assetApp, auth }) {
    return {
        assetList: assetApp.assets.assetList,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetList)));


// WEBPACK FOOTER //
// src/main/content/asset/AssetList.js